import { useMutation } from "react-query";
import { addLeasedEquipmentModel } from "../../../../../actions/Utilities/LeasedEquipmentModel";
import { toast } from "components/toastNotification";
import { IModel } from "../types";

const useAddModel = () => {
  const { mutate } = useMutation(
    (NewData: IModel) => addLeasedEquipmentModel(NewData),
    {
      onSuccess: (res: any) => {
        switch (true) {
          case res == "Success":
            toast.fire("Success", "Model Added Successfully", "success");
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Model Added Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire("Adding Model failed ", `Server Error: ${res}`, "error");
            break;
          case res == "The data already exists!":
            toast.fire(
              "Adding Model failed",
              `Duplication Error: ${res}`,
              "error"
            );
            break;
          case res.includes("Action object"):
            toast.fire("Adding Model failed ", `Error: ${res}`, "error");
            break;
          default:
            toast.fire("Adding Model failed", res.Message, "error");
        }
      },

      onError: (error: any) => {
        toast.fire("Add Model failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
};
export default useAddModel;
